import React, { Component } from 'react';

import "./Mentors.scss"

import Mentor from "./components/Mentor/Mentor"
import MPopup from "./components/Mentor-Popup/Mentor.Popup"

import json from "../../api/data.json"

class Mentors extends Component {
  constructor() {
    super();
    this.onMentorClick = this.onMentorClick.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.state = {
      mentors: {
        minWidth: Math.round((window.screen.width < 1000 ? 140 : 276) * 6) + "px"
      },
      popup: {
        name: "",
        imageURL: ""
      }
    }
  }
  componentDidMount() {
    var width = Math.round(window.document.querySelector("ul .item").clientWidth * window.document.querySelectorAll("ul .item").length);
    this.setState({
      mentors: {
        width: width + "px"
      }
    });
  }
  getItems() {
    return json.mentors.list.map((mentor, index) =>
      <Mentor key={index.toString()} onMentorClick={() => { this.onMentorClick(mentor) }} mentor={mentor} />
    );
  }
  onPopupClose() {
    this.setState({
      popup: {
        isActive: false
      }
    });
  }
  onMentorClick(mentor) {
    this.setState({
      popup: {
        isActive: true,
        name: mentor.name,
        title: mentor.title,
        story: mentor.story,
        imageURL: mentor.imageURL,
        large_imageURL: mentor.large_imageURL,
        credit: mentor.credit,
        offset: window.scrollY
      }
    });
    window.dataLayer.push({
      'event': 'virtualPageview',
      'virtualPageURL': window.document.location.href + mentor.name + "?prof=10.Xnet-11946.xnet.laisha-MyGoal2017",
      'virtualPageTitle': mentor.name
     });
  }
  render() {
    return (
      <figure>
        <MPopup onPopupClose={this.onPopupClose} data={this.state.popup} />
        <section className="section section-mentors">
          <div className="padding">
            <h3 className="headline" dangerouslySetInnerHTML={{ __html: json.mentors.headline }}></h3>
            <div className="container" id="scrollbar">
              <ul style={this.state.mentors}>
                {this.getItems()}
              </ul>
            </div>
          </div>
        </section>
      </figure>
    );
  }
}

export default Mentors;



// WEBPACK FOOTER //
// ./src/components/Mentors/Mentors.js